"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const container = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 24,
    paddingBottom: 24,
};
const titleWrapper = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    color: theme === 'dark' ? constants_1.color.semiWhite : constants_1.color.black,
});
const title = (theme) => ({
    margin: 0,
    fontSize: 32,
    lineHeight: '48px',
    color: theme === 'dark' ? constants_1.color.white : '#404041',
});
const subtitle = {
    margin: 0,
    fontSize: 20,
    lineHeight: '30px',
    fontWeight: 400,
    color: '#AAAAAA',
};
const button = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 40,
    padding: '12px 20px',
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
});
const buttonCustom = (color) => ({
    height: 40,
    minWidth: 150,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonCustomExportExcelRfidlog = (color) => ({
    height: 40,
    minWidth: 190,
    display: 'flex',
    borderRadius: 8,
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonFont = {
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
    marginLeft: 8,
};
const buttonDashboard = (theme, mode) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 40,
    padding: '0px 20px',
    backgroundColor: theme === 'light' ? (mode ? '#8A231C' : '#BA352C') : mode ? '#004040' : constants_1.color.buttonDark,
});
const headerWrapperDashboard = {
    columnGap: 12,
    display: 'grid',
    alignItems: 'flex-end',
    gridTemplateColumns: 'auto auto auto auto'
};
const buttonDashboardFont = {
    margin: 0,
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 'normal',
};
const inputTitle = (theme) => ({
    margin: 0,
    fontSize: '12px',
    marginBottom: '5px',
    color: theme === 'light' ? constants_1.color.darkGrey : constants_1.color.white
});
const colorLabelDate = theme => ({
    height: 'fit-content',
    color: theme === 'light' ? '#000' : '#FFF'
});
const flexWrapper = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
};
const gridWrapper = {
    columnGap: 10,
    display: 'grid',
    alignItems: 'end',
    gridTemplateColumns: 'min-content min-content min-content min-content min-content'
};
const dropdownStyle = theme => ({
    width: 150,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const dropdownMonthStyle = theme => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
    width: '110%'
});
exports.default = {
    title,
    button,
    subtitle,
    container,
    inputTitle,
    buttonFont,
    flexWrapper,
    gridWrapper,
    titleWrapper,
    buttonCustom,
    dropdownStyle,
    colorLabelDate,
    buttonDashboard,
    dropdownMonthStyle,
    buttonDashboardFont,
    headerWrapperDashboard,
    buttonCustomExportExcelRfidlog
};
